import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { AdminDashboard } from '../admin-dashboard';
import { FetchDashboardService } from '../fetch-dashboard.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
  public adminDashoard!: AdminDashboard;
  showDashboard: boolean = true;

  constructor(
    private dashboardService: FetchDashboardService,
    private translate: TranslateService,
    private actionService: ActionsService
  ) {
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
    document.body.classList.remove('dir-rtl');
  }

  async ngOnInit(): Promise<void> {
    await this.getAdminDashoardData();
  }

  async getAdminDashoardData() {
    this.adminDashoard = await this.dashboardService.make();
    console.log(this.adminDashoard.container.cards);
  }

  openModal(target: string) {
    document.getElementById('overlay')!.style.display = 'block';
    document.getElementById(target)!.style.display = 'block';
  }
}
